<template>
  <div class="d-contents">
    <v-skeleton-loader v-if="!projectInfo" type="paragraph" class="p-12" />
    <div v-else class="project-summary__info spacex-20">
      <ui-image
        :id="projectInfo.id"
        :src="projectImage"
        @upload-image="$emit('upload-image', $event)"
        @delete-image="$emit('delete-image')"
      />
      <div class="project-summary__info-list">
        <div v-if="projectInfo.name" class="d-contents">
          <span class="project-summary__name text-bsb">{{ projectInfo.name }}</span>
        </div>
        <div v-if="projectInfo.state" class="d-contents">
          <span class="list-title">{{ $t('Project stage') }}:</span>
          <span class="list-value">{{ project_states[projectInfo.state] }}</span>
        </div>
        <div v-if="projectInfo.price_submission_date" class="d-contents">
          <span class="list-title">{{ $t('Price submission date') }}:</span>
          <span class="list-value">{{ projectInfo.price_submission_date }}</span>
        </div>
        <div v-if="projectInfo.construction_beginning_date" class="d-contents">
          <span class="list-title">{{ $t('Construction beginning date') }}:</span>
          <span class="list-value">{{ projectInfo.construction_beginning_date }}</span>
        </div>
        <div v-if="projectInfo.address" class="d-contents">
          <span class="list-title">{{ $t('Execution address') }}:</span>
          <span class="list-value">{{ projectInfo.address }}</span>
        </div>
        <div v-if="projectInfo.customer" class="d-contents">
          <span class="list-title">{{ $t('Customer') }}:</span>
          <span class="list-value">{{ projectInfo.customer }}</span>
        </div>
      </div>
      <div v-if="projectInfo.description" class="project-summary__info-description">
        <span class="list-title">{{ $t('Description') }}:</span>
        <span class="list-value wrap-text project-description break-word spacex-4">
          {{ projectInfo.description }}
        </span>
        <span class="pointer primary-600 text-sm" @click="$emit('show-more-description')">
          {{ $t('Show more') }}
        </span>
      </div>
    </div>
  </div>
</template>
<script>
  import { VSkeletonLoader } from 'vuetify/lib';
  import { mapState } from 'vuex';
  import UiImage from '@/components/ui/UiImage';

  export default {
    name: 'Info',
    components: {
      UiImage,
      VSkeletonLoader,
    },
    props: {
      projectInfo: [Object, null],
    },
    computed: {
      ...mapState('global', ['project_states']),
      projectImage() {
        return this.projectInfo?.image?.thumbnail || null;
      },
    },
  };
</script>
